<template>
  <div class="product-page bg-light">
    <!-- Navigation Menu -->
    <b-navbar toggleable="lg" type="light" class="border-bottom">
      <b-container>
        <b-navbar-brand style="display: flex;flex-direction: column;justify-content: flex-end;">
          <div style="display: flex;justify-content: space-between;">
            <div class="logo-container">
              <div v-if="imageLoadingStates.logo" class="image-placeholder-small"></div>
              <img @click="goToHref('home')" src="../assets/images/new-logo.png" height="40" 
                  @load="imageLoadingStates.logo = false" 
                  v-show="!imageLoadingStates.logo">
            </div>
            <div style="line-height: 4px;font-size: 12px;color: #666;">
              <p>One stop purchase, In lCQQG !</p>
              <p>WhatsApp: +86 19166251823</p>
              <p>Add to Favorites</p>
            </div>
          </div>
        </b-navbar-brand>
      </b-container>
    </b-navbar>
    <b-navbar toggleable="lg" type="light" class="border-bottom" style="background-color: #eee;">
      <b-container>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item @click="goToHref('home')" active>Home</b-nav-item>
            <b-nav-item to="/">Product Category</b-nav-item>
            <b-nav-item @click="goToHref('news')">News</b-nav-item>
            <b-nav-item @click="goToHref('contact')">Contact Us</b-nav-item>
            <b-nav-item @click="goToHref('about')">About Us</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>
    <!-- Breadcrumb -->
    <nav aria-label="breadcrumb" class="bg-light py-2">
      <div class="container">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item"><a @click="goToHref('home')" style="text-decoration: none;">Home</a></li>
          <li class="breadcrumb-item">
        <router-link :to="{ name: 'ProductList', query: { category: category } }" class="text-decoration-none">
          {{ category }}
        </router-link>
      </li>
      <li class="breadcrumb-item active">{{ product.name }}</li>
        </ol>
      </div>
    </nav>

    <!-- Main Product Section -->
    <div class="container p-4" style="margin-top: -20px;">
      <div class="row bg-white p-4">
        <!-- Product Images -->
        <div class="col-md-5 mb-4">
          <div class="product-gallery border">
            <div class="main-image-container">
              <div v-if="isImageLoading" class="image-loading-placeholder">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
              <img 
                :src="$GLOBAL_CONSTANT + currentImage" 
                class="img-fluid main-image mb-3"
                @load="onImageLoaded"
                v-show="!isImageLoading" 
              >
            </div>
            <div class="d-flex thumbnail-container">
              <div v-for="(image, index) in product.images" :key="index" 
                  class="thumbnail-wrapper" 
                  @click="changeImage(image)"
                  style="cursor: pointer;">
                <div v-if="!thumbnailLoaded[index]" class="thumbnail-placeholder"></div>
                <img :src="$GLOBAL_CONSTANT + image" 
                    class="img-thumbnail" 
                    :class="{ 'border-primary': currentImage === image }"
                    style="width: 80px; height: 80px; object-fit: cover;"
                    @load="thumbnailLoaded[index] = true"
                    v-show="thumbnailLoaded[index]">
              </div>
            </div>
          </div>
        </div>

        <!-- Product Info -->
        <div class="col-md-6" style="margin-left: 2%;">
          <h1 class="h2 mb-3 border-bottom pb-4">{{product.name || ''}}</h1>
          <div v-if="!contentLoaded" class="content-placeholder"></div>
          <p class="text-muted" v-show="contentLoaded">{{product.content}}</p>

          <div class="brand-section mt-4" style="margin-bottom: 6%;">
            <p class="mb-2">Brand:</p>
            <div class="brand-image-container">
              <div v-if="!brandImageLoaded" class="brand-placeholder"></div>
              <img 
                :src="product.brand ? $GLOBAL_CONSTANT + product.brand : ''" 
                style="height: 40px;"
                @load="brandImageLoaded = true"
                v-show="brandImageLoaded && product.brand">
            </div>
          </div>

          <div class="item-overview mb-4">
            <p class="text-muted">Item Overview</p>
            <div class="d-flex mb-4" style="align-items: center;">
              <img src="../assets/images/2.png">
              <span class="text-muted" style="margin: 0 8px;">Condition:</span>
              <span class="badge bg-success" style="display: flex;justify-content: center;align-items: center;">NEW</span>
            </div>
            <div class="d-flex mb-5" style="align-items: center;">
              <img src="../assets/images/3.png">
              <span class="text-muted" style="margin: 0 8px;">Availability:</span>
              <span class="badge bg-primary" style="display: flex;justify-content: center;align-items: center;">In Stock</span>
            </div>
            <button class="btn btn-primary" style="width: 30%;padding: 8px 0;" @click="showQuoteModal = true">Quote</button>
          </div>
        </div>
      </div>

      <!-- Quote Modal -->
    <div style="background-color: rgba(0, 0, 0, 0.5);" class="modal" tabindex="-1" :class="{ 'd-block': showQuoteModal }" v-if="showQuoteModal">
      <div class="modal-dialog" style="margin-top: 240px;">
        <div class="modal-content">
          <button type="button" class="btn-close" @click="showQuoteModal = false"></button>
          <div class="modal-header">
            <h5 class="modal-title">Quote</h5>
          </div>
          <div class="modal-body">
            <form @submit.prevent="submitQuote">
              <div class="mb-3">
                <div class="form-groups">
                  <div class="form-labels">Partnum *</div>
                  <div class="form-control-wraps"><input type="text" class="form-control" :value="product.name" readonly></div>
                </div>
              </div>
              <div class="mb-3">
                <div class="form-groups">
                  <div class="form-labels">Qty *</div>
                  <div class="form-control-wraps"><input type="number" class="form-control" v-model="quoteForm.num" min="1"></div>
                </div>
              </div>
              <div class="mb-4">
                <div class="form-groups">
                  <div class="form-labels">Email *</div>
                  <div class="form-control-wraps"><input type="text" class="form-control" v-model="quoteForm.email"></div>
                </div>
              </div>
              <div class="text-center">
                <button type="submit" class="btn btn-primary form-submit-btn">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

      <!-- Product Specifications -->
      <div class="row mt-5 bg-white p-4">
        <div class="col-12">
          <h2 class="h4 pb-2 mb-4" style="border-left: 5px solid #007bff;padding-left: 10px;padding-top: 10px;">Product Overview</h2>
          <div v-if="!detailsLoaded" class="details-placeholder">
            <div class="placeholder-line"></div>
            <div class="placeholder-line"></div>
            <div class="placeholder-line"></div>
            <div class="placeholder-line" style="width: 80%;"></div>
            <div class="placeholder-line" style="width: 60%;"></div>
          </div>
          <div class="specifications" v-html="product.details" v-show="detailsLoaded" @load="detailsLoaded = true"></div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <footer class="mt-5 py-4 pb-5" style="background-color: rgb(236, 236, 236);">
      <div class="container">
        <!-- Contact Form -->
      <div class="row mt-5">
        <div class="col-12">
          <div class="contact-form border-bottom pb-4">
            <h3 class="h4 mb-4">Welcome To Leave Us A Message</h3>
            <form @submit.prevent="submitForm">
              <div class="row">
                <div class="col-md-2 mb-3">
                  <input type="text" class="form-control" v-model="quoteForms.name" placeholder="Your name *">
                </div>
                <div class="col-md-2 mb-3">
                  <input type="text" class="form-control" v-model="quoteForms.email" placeholder="Email or phone *">
                </div>
                <div class="col-md-2 mb-3">
                  <input type="text" class="form-control" v-model="quoteForms.company" placeholder="Your Company">
                </div>
                <div class="col-md-4 mb-3">
                  <input type="text" class="form-control" v-model="quoteForms.message" placeholder="Your Message *">
                </div>
                <div class="col-md-2 mb-3">
                  <button style="height: 95%;" type="submit" class="btn btn-primary w-100">Submit</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
        <div class="row mt-4">
          <div class="col-md-7">
            <h4 class="h5">Product Category</h4>
            <ul class="list-unstyled mt-4">
  <li><router-link :to="{ name: 'ProductList', query: { category: 'ConnectX-7' } }" class="text-decoration-none">ConnectX-7</router-link></li>
  <li><router-link :to="{ name: 'ProductList', query: { category: 'ConnectX-6' } }" class="text-decoration-none">ConnectX-6</router-link></li>
  <li><router-link :to="{ name: 'ProductList', query: { category: 'ConnectX-5' } }" class="text-decoration-none">ConnectX-5</router-link></li>
  <li><router-link :to="{ name: 'ProductList', query: { category: 'ConnectX-4' } }" class="text-decoration-none">ConnectX-4</router-link></li>
</ul>
          </div>
          <div class="col-md-3 text-center border-start border-end">
            <p class="mb-2">+86 19166251823</p>
            <p style="color: rgb(157, 159, 162);">ShangHai Mon-Fri 9:30-19:30</p>
            <button class="btn-outline-secondary btn-sm" style="border-radius: 50px;padding: 5px 15px;color: rgb(157, 159, 162);border: 1px solid rgb(157, 159, 162);">
              <img style="margin-right: 10px;" src="../assets/images/4.png">Online
            </button>
          </div>
          <div class="col-md-2 text-center" style="color: rgb(157, 159, 162);">
            <p class="mb-2">WeChat</p>
            <div class="wechat-qr-container">
              <div v-if="!qrCodeLoaded" class="qrcode-placeholder"></div>
              <img 
                src="../assets/images/5.png" 
                style="width: 120px;"
                @load="qrCodeLoaded = true"
                v-show="qrCodeLoaded">
            </div>
          </div>
        </div>
      </div>
    </footer>

    <global-component :product="product.name"></global-component>
  </div>
</template>

<script>
import api from '../api/api';

export default {
  name: 'ProductDetails',
  props: ['category', 'id'],
  data() {
    return {
      product: {},
      quoteForm: {
        name: '',
        num: 1,
        email: '',
      },
      quoteForms: {
        name: '',
        email: '',
        company: '',
        message: '',
        type: 2
      },
      showQuoteModal: false,
      currentImage: '',
      selectedImage: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/02.jpg-KTE9sf491mDk8FEZ7P4QUBl7u8wCql.jpeg',
      productImages: [
        'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/02.jpg-KTE9sf491mDk8FEZ7P4QUBl7u8wCql.jpeg',
        'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/02.jpg-KTE9sf491mDk8FEZ7P4QUBl7u8wCql.jpeg',
        'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/02.jpg-KTE9sf491mDk8FEZ7P4QUBl7u8wCql.jpeg',
        'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/02.jpg-KTE9sf491mDk8FEZ7P4QUBl7u8wCql.jpeg'
      ],
      cacheExpiryTime: 60 * 60 * 1000, // 缓存过期时间：1小时
      isImageLoading: true, // 图片加载状态
      preloadedImages: {}, // 预加载图片缓存
      thumbnailLoaded: {}, // 缩略图加载状态
      brandImageLoaded: false, // 品牌图片加载状态
      qrCodeLoaded: false, // 二维码图片加载状态
      contentLoaded: false, // 内容加载状态
      detailsLoaded: false, // 详情加载状态
      imageLoadingStates: {
        logo: true
      }
    }
  },
  mounted() {
    console.log('Category:', this.category); // 添加调试信息
    console.log('ID:', this.id);
    if (this.id) {
      // 先尝试从缓存加载
      const loadedFromCache = this.loadProductDetailFromCache(this.id);
      if (loadedFromCache) {
        // 如果成功从缓存加载，延迟显示内容，模拟加载效果
        setTimeout(() => {
          this.contentLoaded = true;
          this.detailsLoaded = true;
        }, 300);
      }
      // 然后请求最新数据
      this.networkCardDetail(this.id);
    }
  },
  watch: {
    // 监听产品数据变化，更新加载状态
    'product': {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          // 当产品数据加载完成，更新内容加载状态
          setTimeout(() => {
            this.contentLoaded = true;
            this.detailsLoaded = true;
          }, 300);
          
          // 初始化缩略图加载状态
          if (newVal.images && newVal.images.length > 0) {
            newVal.images.forEach((_, index) => {
              this.thumbnailLoaded[index] = false;
            });
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    // 从缓存加载产品详情
    loadProductDetailFromCache(productId) {
      try {
        const cacheKey = `productDetail_${productId}`;
        const cachedData = localStorage.getItem(cacheKey);
        
        if (cachedData) {
          const { product, timestamp } = JSON.parse(cachedData);
          
          // 检查缓存是否过期
          if (timestamp && Date.now() - timestamp < this.cacheExpiryTime) {
            this.product = product;
            this.currentImage = product.url;
            console.log('Product detail loaded from cache');
            return true;
          } else {
            // 缓存过期，清除旧缓存
            localStorage.removeItem(cacheKey);
            console.log('Cache expired, removed old cache');
          }
        }
      } catch (error) {
        console.error('Error loading product detail from cache:', error);
        // 如果解析缓存出错，则清除缓存
        const cacheKey = `productDetail_${productId}`;
        localStorage.removeItem(cacheKey);
      }
      return false;
    },
    
    // 更新缓存
    updateProductDetailCache(productId, productData) {
      try {
        const cacheKey = `productDetail_${productId}`;
        const cacheData = {
          product: productData,
          timestamp: Date.now()
        };
        
        localStorage.setItem(cacheKey, JSON.stringify(cacheData));
        console.log('Product detail cache updated');
      } catch (error) {
        console.error('Error updating product detail cache:', error);
      }
    },
    
    // 比较数据是否相同
    isProductDataDifferent(oldData, newData) {
      if (!oldData || !newData) {
        return true;
      }
      
      // 检查主要字段是否变化
      return oldData.id !== newData.id || 
             oldData.name !== newData.name || 
             oldData.content !== newData.content || 
             oldData.details !== newData.details ||
             oldData.updated_at !== newData.updated_at;
    },
    
    // 图片加载完成处理
    onImageLoaded() {
      this.isImageLoading = false;
    },
    
    // 预加载图片
    preloadImage(src) {
      // 如果已经预加载过，则不再重复预加载
      if (this.preloadedImages[src]) {
        return Promise.resolve();
      }
      
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          this.preloadedImages[src] = true;
          resolve();
        };
        img.onerror = reject;
        img.src = this.$GLOBAL_CONSTANT + src;
      });
    },
    
    // 切换图片
    async changeImage(image) {
      if (this.currentImage === image) return;
      
      this.isImageLoading = true;
      try {
        await this.preloadImage(image);
        this.currentImage = image;
        // 预加载可能已完成，手动触发加载完成事件
        this.$nextTick(() => {
          // 如果图片已在缓存中，可能不会触发load事件，所以这里手动设置加载完成
          const mainImg = document.querySelector('.main-image');
          if (mainImg && mainImg.complete) {
            this.isImageLoading = false;
          }
        });
      } catch (error) {
        console.error('Failed to load image:', error);
        this.isImageLoading = false;
      }
    },
    
    async networkCardDetail(id) {
      try {
        const response = await api.getProductDetail(id);
        const newProductData = response.data;
        
        // 处理图片数据
        if (typeof newProductData.images === 'string') {
          newProductData.images = newProductData.images.split(',');
        }
        
        // 检查是否需要更新
        if (this.isProductDataDifferent(this.product, newProductData)) {
          // 更新当前展示的数据
          this.product = newProductData;
          this.currentImage = newProductData.url;
          
          // 开始预加载所有图片
          if (newProductData.images && newProductData.images.length > 0) {
            // 首先预加载主图
            this.preloadImage(newProductData.url)
              .then(() => {
                // 主图加载完成后，预加载其他图片
                newProductData.images.forEach(img => {
                  this.preloadImage(img);
                });
              })
              .catch(err => {
                console.error('Failed to preload main image:', err);
              });
          }
          
          // 更新缓存
          this.updateProductDetailCache(id, newProductData);
          console.log('Product detail updated from API');
        } else {
          console.log('Product detail unchanged, using cached data');
        }
      } catch (error) {
        console.error('There was an error fetching the product detail:', error);
        // 如果API请求失败但已经从缓存加载了数据，则继续使用缓存数据
        if (Object.keys(this.product).length === 0) {
          // 再次尝试从缓存加载
          this.loadProductDetailFromCache(id);
        }
      }
    },
    async submitQuote() {
      if (!this.product.name || !this.quoteForm.num || !this.quoteForm.email) {
        this.$mMessage.error("Please fill in all required fields.");
        return;
      }
      const myreg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      if(!myreg.test(this.quoteForm.email)){
        this.$mMessage.error("email is not valid.");
        return;
      }
      try {
        const data = {
          model: this.product.name,
          num: this.quoteForm.num,
          email: this.quoteForm.email,
          type: 1
        };
        const response = await api.addFormSubmit(data);
        console.log('Quote submitted successfully:', response.data);
        // 显示成功消息
        this.$mMessage.success("Quote submitted successfully!");
        // 关闭模态框
        this.showQuoteModal = false;
        // 重置表单
        this.quoteForm.num = 1;
        this.quoteForm.email = '';
      } catch (error) {
        console.error('There was an error submitting the quote:', error);
        // 显示错误消息
        // this.$toast.error("Failed to submit quote. Please try again.");
      }
    },
    async submitForm() {
      if (!this.quoteForms.name || !this.quoteForms.message || !this.quoteForms.email) {
        this.$mMessage.error("Please fill in all required fields.");
        return;
      }
      const myreg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      if(!myreg.test(this.quoteForms.email)){
        this.$mMessage.error("email is not valid.");
        return;
      }
      try {
        const response = await api.addFormSubmit(this.quoteForms);
        console.log('Quote submitted successfully:', response.data);
        // 显示成功消息
        this.$mMessage.success("Message submitted successfully!");
        // 关闭模态框
        // this.showQuoteModal = false;
        // 重置表单
        this.quoteForms.name = '';
        this.quoteForms.email = '';
        this.quoteForms.company = '';
        this.quoteForms.message = '';
      } catch (error) {
        console.error('There was an error submitting the quote:', error);
        // 显示错误消息
        // this.$toast.error("Failed to submit quote. Please try again.");
      }
    },
    goToHref(type) {
      if(type == 'home') {
        window.location.href = 'https://en.icqqg.com';
      } else if(type == 'contact') {
        window.location.href = 'https://en.icqqg.com/bom';
      } else if(type == 'about') {
        window.location.href = 'https://en.icqqg.com/about';
      } else if(type == 'news') {
        window.location.href = 'https://en.icqqg.com/news/type/1';
      }
    }
  }
}
</script>

<style>
.product-page {
  color: #333;
  width: 100%;
  height: 100%;
}

.main-image-container {
  position: relative;
  min-height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-loading-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f8f9fa;
}

.main-image {
  max-height: 400px;
  object-fit: contain;
}

.thumbnail-container {
  overflow-x: auto;
}

.thumbnail-item {
  cursor: pointer;
  width: 80px;
  flex-shrink: 0;
}

.thumbnail-item img {
  height: 80px;
  object-fit: cover;
}

.specifications p {
  color: #666;
  line-height: 1.6;
}

.form-groups {
  display: flex;
  width: 100%;
  height: 50px;
}

.form-labels {
  width: 20%;
  background-color: rgb(231, 236, 240);
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

.form-control-wraps {
  width: 80%;
  
  input {
    height: 50px;
    border-top-left-radius: 0%;
    border-bottom-left-radius: 0%;
  }
}

.modal-content {
  padding: 40px;
}

.modal {
  --bs-modal-width: 650px;
}

.modal-header {
  display: block !important;
  text-align: center;
}

.form-submit-btn {
  width: 25%;
  padding: 10px 0;
}

.btn-close {
  position: absolute;
  right: 3%;
  top: 5%;
}

.nav-item {
  margin-left: -8px;
  margin-right: 50px;
}

.nav-link {
  color: black !important;
  font-weight: bold !important;
}

.product-gallery {
  text-align: center;
  padding: 3%;
}

.list-unstyled {
  padding-right: 0%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  
  a {
    color: black !important;
  }
}

.text-decoration-none {
  color: black !important;
}

.thumbnail-wrapper {
  margin-right: 3%;
}

.main-image {
  height: 350px !important;
}

.form-control {
    height: 50px;
    border-top-left-radius: 0% !important;
    border-bottom-left-radius: 0% !important;
}

tbody, td, tfoot, th, thead, tr {
  border-style: inset !important;
  border-width: 1px !important;
}

@media (max-width: 768px) {
  .main-image {
    max-height: 300px;
  }
  
  .thumbnail-item {
    width: 60px;
  }
  
  .thumbnail-item img {
    height: 60px;
  }

  .modal-content {
    padding: 0px;
  }

  .list-unstyled{
    display: block;
  }

  .cb{
    width: 48px !important;
  }
}

.thumbnail-placeholder,
.brand-placeholder,
.qrcode-placeholder,
.image-placeholder-small {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.thumbnail-placeholder {
  width: 80px;
  height: 80px;
}

.brand-placeholder {
  width: 120px;
  height: 40px;
}

.qrcode-placeholder {
  width: 120px;
  height: 120px;
  margin: 0 auto;
}

.image-placeholder-small {
  width: 40px;
  height: 40px;
}

.content-placeholder,
.details-placeholder {
  width: 100%;
}

.content-placeholder {
  height: 80px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-bottom: 15px;
  border-radius: 4px;
}

.placeholder-line {
  height: 16px;
  width: 100%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-bottom: 10px;
  border-radius: 2px;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.wechat-qr-container,
.brand-image-container {
  display: flex;
}
</style>